import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export function initClientCarousel() {
  const swiper = new Swiper('.client-carousel', {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
    }
  });
}